import type { TextSelectionContext } from '@/types/ai';
import type {
  EditorImmerGetState,
  EditorImmerSetState,
} from './editor-store-types';

export interface TextSelectionSlice {
  // Phase 5: Text Selection State
  textSelection: TextSelectionContext | null;

  // Inline Text Editing State
  textEditingComponentId: string | null;

  // Phase 5: Text Selection actions
  setTextSelection: (selection: TextSelectionContext | null) => void;
  clearTextSelection: () => void;
  getTextSelection: () => TextSelectionContext | null;

  // Inline Text Editing actions
  setTextEditingComponent: (componentId: string | null) => void;
  isTextEditing: (componentId: string) => boolean;
}

export const textSelectionInitialState: Pick<
  TextSelectionSlice,
  'textSelection' | 'textEditingComponentId'
> = {
  // Phase 5: Text Selection initial state
  textSelection: null,

  // Inline Text Editing initial state
  textEditingComponentId: null,
};

export function createTextSelectionSlice<TState extends TextSelectionSlice>(
  set: EditorImmerSetState<TState>,
  get: EditorImmerGetState<TState>,
): TextSelectionSlice {
  return {
    ...textSelectionInitialState,

    // Phase 5: Text Selection actions
    setTextSelection: (selection) => {
      set((state) => {
        console.log('[Phase 5.2] Setting text selection:', selection);
        state.textSelection = selection;
      });
    },

    clearTextSelection: () => {
      set((state) => {
        console.log('[Phase 5.2] Clearing text selection');
        state.textSelection = null;
      });
    },

    getTextSelection: () => {
      return get().textSelection;
    },

    // Inline Text Editing actions
    setTextEditingComponent: (componentId) => {
      set((state) => {
        console.log(
          '[Inline Text Editing] Setting editing component:',
          componentId,
        );
        state.textEditingComponentId = componentId;
      });
    },

    isTextEditing: (componentId) => {
      return get().textEditingComponentId === componentId;
    },
  };
}
